function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (factory, window) {
  if (typeof define === "function" && define.amd) {
    define(["leaflet"], factory);
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    module.exports = factory(require("leaflet"));
  }

  if (typeof window !== "undefined" && window.L) {
    window.L.Control.MiniMap = factory(L);

    window.L.control.minimap = function (layer, options) {
      return new window.L.Control.MiniMap(layer, options);
    };
  }
})(function (L) {
  var MiniMap = L.Control.extend({
    includes: L.Evented ? L.Evented.prototype : L.Mixin.Events,
    options: {
      position: "bottomright",
      toggleDisplay: false,
      zoomLevelOffset: -5,
      zoomLevelFixed: false,
      centerFixed: false,
      zoomAnimation: false,
      autoToggleDisplay: false,
      minimized: false,
      width: 150,
      height: 150,
      collapsedWidth: 19,
      collapsedHeight: 19,
      aimingRectOptions: {
        color: "#ff7800",
        weight: 1,
        clickable: false
      },
      shadowRectOptions: {
        color: "#000000",
        weight: 1,
        clickable: false,
        opacity: 0,
        fillOpacity: 0
      },
      strings: {
        hideText: "Hide MiniMap",
        showText: "Show MiniMap"
      },
      mapOptions: {}
    },
    initialize: function initialize(layer, options) {
      L.Util.setOptions(this, options);
      this.options.aimingRectOptions.clickable = false;
      this.options.shadowRectOptions.clickable = false;
      this._layer = layer;
    },
    onAdd: function onAdd(map) {
      this._mainMap = map;
      this._container = L.DomUtil.create("div", "leaflet-control-minimap");
      this._container.style.width = this.options.width + "px";
      this._container.style.height = this.options.height + "px";
      L.DomEvent.disableClickPropagation(this._container);
      L.DomEvent.on(this._container, "mousewheel", L.DomEvent.stopPropagation);
      var mapOptions = {
        attributionControl: false,
        dragging: !this.options.centerFixed,
        zoomControl: false,
        zoomAnimation: this.options.zoomAnimation,
        autoToggleDisplay: this.options.autoToggleDisplay,
        touchZoom: this.options.centerFixed ? "center" : !this._isZoomLevelFixed(),
        scrollWheelZoom: this.options.centerFixed ? "center" : !this._isZoomLevelFixed(),
        doubleClickZoom: this.options.centerFixed ? "center" : !this._isZoomLevelFixed(),
        boxZoom: !this._isZoomLevelFixed(),
        crs: map.options.crs
      };
      mapOptions = L.Util.extend(this.options.mapOptions, mapOptions);
      this._miniMap = new L.Map(this._container, mapOptions);

      this._miniMap.addLayer(this._layer);

      this._mainMapMoving = false;
      this._miniMapMoving = false;
      this._userToggledDisplay = false;
      this._minimized = false;

      if (this.options.toggleDisplay) {
        this._addToggleButton();
      }

      this._miniMap.whenReady(L.Util.bind(function () {
        this._aimingRect = L.rectangle(this._mainMap.getBounds(), this.options.aimingRectOptions).addTo(this._miniMap);
        this._shadowRect = L.rectangle(this._mainMap.getBounds(), this.options.shadowRectOptions).addTo(this._miniMap);

        this._mainMap.on("moveend", this._onMainMapMoved, this);

        this._mainMap.on("move", this._onMainMapMoving, this);

        this._miniMap.on("movestart", this._onMiniMapMoveStarted, this);

        this._miniMap.on("move", this._onMiniMapMoving, this);

        this._miniMap.on("moveend", this._onMiniMapMoved, this);
      }, this));

      return this._container;
    },
    addTo: function addTo(map) {
      L.Control.prototype.addTo.call(this, map);

      var center = this.options.centerFixed || this._mainMap.getCenter();

      this._miniMap.setView(center, this._decideZoom(true));

      this._setDisplay(this.options.minimized);

      return this;
    },
    onRemove: function onRemove(map) {
      this._mainMap.off("moveend", this._onMainMapMoved, this);

      this._mainMap.off("move", this._onMainMapMoving, this);

      this._miniMap.off("moveend", this._onMiniMapMoved, this);

      this._miniMap.removeLayer(this._layer);
    },
    changeLayer: function changeLayer(layer) {
      this._miniMap.removeLayer(this._layer);

      this._layer = layer;

      this._miniMap.addLayer(this._layer);
    },
    _addToggleButton: function _addToggleButton() {
      this._toggleDisplayButton = this.options.toggleDisplay ? this._createButton("", this._toggleButtonInitialTitleText(), "leaflet-control-minimap-toggle-display leaflet-control-minimap-toggle-display-" + this.options.position, this._container, this._toggleDisplayButtonClicked, this) : undefined;
      this._toggleDisplayButton.style.width = this.options.collapsedWidth + "px";
      this._toggleDisplayButton.style.height = this.options.collapsedHeight + "px";
    },
    _toggleButtonInitialTitleText: function _toggleButtonInitialTitleText() {
      if (this.options.minimized) {
        return this.options.strings.showText;
      } else {
        return this.options.strings.hideText;
      }
    },
    _createButton: function _createButton(html, title, className, container, fn, context) {
      var link = L.DomUtil.create("a", className, container);
      link.innerHTML = html;
      link.href = "#";
      link.title = title;
      var stop = L.DomEvent.stopPropagation;
      L.DomEvent.on(link, "click", stop).on(link, "mousedown", stop).on(link, "dblclick", stop).on(link, "click", L.DomEvent.preventDefault).on(link, "click", fn, context);
      return link;
    },
    _toggleDisplayButtonClicked: function _toggleDisplayButtonClicked() {
      this._userToggledDisplay = true;

      if (!this._minimized) {
        this._minimize();
      } else {
        this._restore();
      }
    },
    _setDisplay: function _setDisplay(minimize) {
      if (minimize !== this._minimized) {
        if (!this._minimized) {
          this._minimize();
        } else {
          this._restore();
        }
      }
    },
    _minimize: function _minimize() {
      if (this.options.toggleDisplay) {
        this._container.style.width = this.options.collapsedWidth + "px";
        this._container.style.height = this.options.collapsedHeight + "px";
        this._toggleDisplayButton.className += " minimized-" + this.options.position;
        this._toggleDisplayButton.title = this.options.strings.showText;
      } else {
        this._container.style.display = "none";
      }

      this._minimized = true;

      this._onToggle();
    },
    _restore: function _restore() {
      if (this.options.toggleDisplay) {
        this._container.style.width = this.options.width + "px";
        this._container.style.height = this.options.height + "px";
        this._toggleDisplayButton.className = this._toggleDisplayButton.className.replace("minimized-" + this.options.position, "");
        this._toggleDisplayButton.title = this.options.strings.hideText;
      } else {
        this._container.style.display = "block";
      }

      this._minimized = false;

      this._onToggle();
    },
    _onMainMapMoved: function _onMainMapMoved(e) {
      if (!this._miniMapMoving) {
        var center = this.options.centerFixed || this._mainMap.getCenter();

        this._mainMapMoving = true;

        this._miniMap.setView(center, this._decideZoom(true));

        this._setDisplay(this._decideMinimized());
      } else {
        this._miniMapMoving = false;
      }

      this._aimingRect.setBounds(this._mainMap.getBounds());
    },
    _onMainMapMoving: function _onMainMapMoving(e) {
      this._aimingRect.setBounds(this._mainMap.getBounds());
    },
    _onMiniMapMoveStarted: function _onMiniMapMoveStarted(e) {
      if (!this.options.centerFixed) {
        var lastAimingRect = this._aimingRect.getBounds();

        var sw = this._miniMap.latLngToContainerPoint(lastAimingRect.getSouthWest());

        var ne = this._miniMap.latLngToContainerPoint(lastAimingRect.getNorthEast());

        this._lastAimingRectPosition = {
          sw: sw,
          ne: ne
        };
      }
    },
    _onMiniMapMoving: function _onMiniMapMoving(e) {
      if (!this.options.centerFixed) {
        if (!this._mainMapMoving && this._lastAimingRectPosition) {
          this._shadowRect.setBounds(new L.LatLngBounds(this._miniMap.containerPointToLatLng(this._lastAimingRectPosition.sw), this._miniMap.containerPointToLatLng(this._lastAimingRectPosition.ne)));

          this._shadowRect.setStyle({
            opacity: 1,
            fillOpacity: .3
          });
        }
      }
    },
    _onMiniMapMoved: function _onMiniMapMoved(e) {
      if (!this._mainMapMoving) {
        this._miniMapMoving = true;

        this._mainMap.setView(this._miniMap.getCenter(), this._decideZoom(false));

        this._shadowRect.setStyle({
          opacity: 0,
          fillOpacity: 0
        });
      } else {
        this._mainMapMoving = false;
      }
    },
    _isZoomLevelFixed: function _isZoomLevelFixed() {
      var zoomLevelFixed = this.options.zoomLevelFixed;
      return this._isDefined(zoomLevelFixed) && this._isInteger(zoomLevelFixed);
    },
    _decideZoom: function _decideZoom(fromMaintoMini) {
      if (!this._isZoomLevelFixed()) {
        if (fromMaintoMini) {
          return this._mainMap.getZoom() + this.options.zoomLevelOffset;
        } else {
          var currentDiff = this._miniMap.getZoom() - this._mainMap.getZoom();

          var proposedZoom = this._miniMap.getZoom() - this.options.zoomLevelOffset;
          var toRet;

          if (currentDiff > this.options.zoomLevelOffset && this._mainMap.getZoom() < this._miniMap.getMinZoom() - this.options.zoomLevelOffset) {
            if (this._miniMap.getZoom() > this._lastMiniMapZoom) {
              toRet = this._mainMap.getZoom() + 1;

              this._miniMap.setZoom(this._miniMap.getZoom() - 1);
            } else {
              toRet = this._mainMap.getZoom();
            }
          } else {
            toRet = proposedZoom;
          }

          this._lastMiniMapZoom = this._miniMap.getZoom();
          return toRet;
        }
      } else {
        if (fromMaintoMini) {
          return this.options.zoomLevelFixed;
        } else {
          return this._mainMap.getZoom();
        }
      }
    },
    _decideMinimized: function _decideMinimized() {
      if (this._userToggledDisplay) {
        return this._minimized;
      }

      if (this.options.autoToggleDisplay) {
        if (this._mainMap.getBounds().contains(this._miniMap.getBounds())) {
          return true;
        }

        return false;
      }

      return this._minimized;
    },
    _isInteger: function _isInteger(value) {
      return typeof value === "number";
    },
    _isDefined: function _isDefined(value) {
      return typeof value !== "undefined";
    },
    _onToggle: function _onToggle() {
      L.Util.requestAnimFrame(function () {
        L.DomEvent.on(this._container, "transitionend", this._fireToggleEvents, this);

        if (!L.Browser.any3d) {
          L.Util.requestAnimFrame(this._fireToggleEvents, this);
        }
      }, this);
    },
    _fireToggleEvents: function _fireToggleEvents() {
      L.DomEvent.off(this._container, "transitionend", this._fireToggleEvents, this);
      var data = {
        minimized: this._minimized
      };
      this.fire(this._minimized ? "minimize" : "restore", data);
      this.fire("toggle", data);
    }
  });
  L.Map.mergeOptions({
    miniMapControl: false
  });
  L.Map.addInitHook(function () {
    if (this.options.miniMapControl) {
      this.miniMapControl = new MiniMap().addTo(this);
    }
  });
  return MiniMap;
}, window);